const URL_PATTERN = /https?:\/\/[^\s<>"']+/i

export function extractPostText(text) {
  const match = text.match(URL_PATTERN)

  if (!match) {
    return { body: text.trim(), url: "" }
  }

  const rawUrl = match[0]
  const url = rawUrl.replace(/[),.!?;:]+$/, "")
  const before = text.slice(0, match.index)
  const after = text.slice(match.index + rawUrl.length)
  const body = `${before}${after}`
    .replace(/[ \t]+\n/g, "\n")
    .replace(/\n[ \t]+/g, "\n")
    .replace(/[ \t]{2,}/g, " ")
    .trim()

  return { body, url }
}
